
(function () {
  function init(root) {
    (root || document).querySelectorAll('sh-shop-showcase').forEach(function (shell) {
      if (shell.dataset.ready === 'true') return;
      shell.dataset.ready = 'true';

      var track = shell.querySelector('[data-sh-track]');
      var prev = shell.querySelector('[data-sh-prev]');
      var next = shell.querySelector('[data-sh-next]');
      var dots = Array.prototype.slice.call(shell.querySelectorAll('[data-sh-dot]'));

      if (!track) return;

      function getStep() {
        var card = track.querySelector('.sh-shop-card');
        if (!card) return track.clientWidth;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 0);
        return card.getBoundingClientRect().width + gap;
      }

      function updateDots() {
        if (!dots.length) return;
        var index = Math.round(track.scrollLeft / getStep());
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: getStep(), behavior: 'smooth' });
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.getAttribute('data-sh-dot'), 10) || 0;
          track.scrollTo({ left: getStep() * index, behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateDots);
      }, { passive: true });

      window.addEventListener('resize', updateDots);
      updateDots();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
